import { Box, Grid, Typography, useTheme } from '@mui/material'
import PublicMainContainer from '../../../layouts/public/PublicMainContainer'
import FormOptionCard from './components/FormOptionCard'
import forms from './dummy-data'

export default function PublicHomePage() {
  const theme = useTheme()

  return (
    <PublicMainContainer>
      <Box sx={{ p: 4 }}>
        <Typography variant='h6' mb={3} color={theme.palette.primary.main}>
          {'What do you need to submit today? :)'}
        </Typography>
        <Grid container spacing={4}>
          {forms.map((item, index) => (
            <Grid key={`public-home-form-card-${index}`} size={{ xs: 12, md: 4 }}>
              <FormOptionCard
                label={item.label}
                subheader={item.subheader}
                bannerUrl={item.bannerUrl}
                link={item.link}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </PublicMainContainer>
  )
}
